import React from 'react';
import { Route, IndexRoute } from 'react-router';

import * as routes from './constants/routesNames';
import App from './components/App';
import HomePage from './components/HomePage';
import ContactPage from './components/ContactPage';
import ProjectPageContainer from './components/ProjectPage';

export default (
  <Route path={routes.HOMEPAGE} component={App}>
    <IndexRoute component={HomePage}/>
    <Route path={routes.CONTACT} component={ContactPage}/>
    <Route path={routes.PROJECT} component={ProjectPageContainer}/>
  </Route>
);



// WEBPACK FOOTER //
// ./src/routes.js